import React from 'react'

// ArComponents
import ArHeroHeader from 'src/components/ArHeroHeader/ArHeroHeader'
import ArItemsWithDescription from 'src/components/ArItemsWithDescription/ArItemsWithDescription'
import ArColumnsWithDescription from 'src/components/ArColumnsWithDescription/ArColumnsWithDescription'
import ArPartners from 'src/components/ArPartners/ArPartners'
import ArTestimonials from 'src/components/ArTestimonials/ArTestimonials'
import ArCTASection from 'src/components/ArCTASection/ArCTASection'
import ArSeo from 'src/components/ArSeo/ArSeo'

import DaPageHomeData from 'src/data/PageHome'
import DaDataCommon from 'src/data/DataCommon'

export default class HomePage extends React.Component {
  render () {
    return (
      <React.Fragment>
        <ArSeo
          title={DaPageHomeData.metadata.title}
          description={DaPageHomeData.metadata.desc}
        />

        <>
          {(() => {
            const {
              videoMobile,
              videoTablet,
              videoDesktop,
              title,
              description,
              cta,
            } = DaPageHomeData.ArHeroHeader
            return (
              <ArHeroHeader
                variant="homepage"
                videoMobile={videoMobile}
                videoTablet={videoTablet}
                videoDesktop={videoDesktop}
                title={title}
                description={description}
                cta={cta}
              />
            )
          })()}

          {/* {(() => {
            const { title, description } = DaPageHomeData.ArPostSimple
            return (
              <ArPostSimple
                title={title}
                description={description}
              />
            )
          })()} */}

          {(() => {
            const { title, description, items, cta } = DaPageHomeData.ArItemsWithDescription

            return (
              <ArItemsWithDescription
                title={title}
                description={description}
                items={items}
                cta={cta}
              />
            )
          })()}

          {(() => {
            const { title, description, columns } = DaPageHomeData.ArColumnsWithDescription

            return (
              <ArColumnsWithDescription
                title={title}
                description={description}
                columns={columns}
              />
            )
          })()}

          {(() => {
            const { title, logos } = DaDataCommon.ArPartners

            return (
              <ArPartners title={title} logos={logos} />
            )
          })()}

          {(() => {
            return (
              <ArTestimonials testimonials={DaDataCommon.ArTestimonials} />
            )
          })()}

          {(() => {
            const { title, cta, backgroundColor } = DaDataCommon.ArCTASection

            return (
              <ArCTASection title={title} cta={cta} scBackgroundColor={backgroundColor} />
            )
          })()}
        </>
      </React.Fragment>
    )
  }
}
